/**
 * Falllisten-Suche: nur Akten, die der Sitz schon sieht.
 * Treffer aus Name, Datum und den Anhaltspunkten an der Akte
 * (Titel, Datum, Fristen-Namen, Dokumentnamen). Keine fremde Akte, keine Normsuche.
 */

export type PortalAkteListSearchRow = {
  id: string;
  title: string;
  created?: string | null;
  updated?: string | null;
  mandant_label?: string | null;
  gegenseite_label?: string | null;
};

export type PortalAkteListSearchExtras = {
  documentNames?: string[];
  fristNames?: string[];
};

function isoDayVariants(value?: string | null): string[] {
  const raw = value?.trim() ?? '';
  if (!raw) return [];
  const day = raw.slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  const out = [raw.toLowerCase()];
  if (match) {
    out.push(`${match[3]}.${match[2]}.${match[1]}`.toLowerCase());
    out.push(`${match[2]}.${match[1]}`.toLowerCase());
    out.push(match[1]);
  }
  return out;
}

export function portalAkteListSearchHaystack(
  row: PortalAkteListSearchRow,
  extras?: PortalAkteListSearchExtras,
): string {
  const parts = [
    row.title,
    row.mandant_label,
    row.gegenseite_label,
    ...isoDayVariants(row.created),
    ...isoDayVariants(row.updated),
    ...(extras?.documentNames ?? []),
    ...(extras?.fristNames ?? []),
  ];
  return parts
    .map((part) => (part ?? '').trim().toLowerCase())
    .filter(Boolean)
    .join('\n');
}

/** Leere Eingabe lässt die Liste unverändert. Sonst nur Zeilen mit Treffer. */
export function filterPortalAkteList<T extends PortalAkteListSearchRow>(
  rows: T[],
  query: string,
  extrasById?: Record<string, PortalAkteListSearchExtras | undefined>,
): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return rows;
  return rows.filter((row) =>
    portalAkteListSearchHaystack(row, extrasById?.[row.id]).includes(needle),
  );
}
